export default {
  name: "mTab",
  props: {
    tab: {
      default: () => []
    },
    selectTab: {
      default: null
    }
  },
  watch: {
    tab: {
      handler(newList, oldList) {
        console.log("newListnewListnewList", newList);
        if (newList.length > 0 && newList != oldList) {
          this.$emit("update:selectTab", newList[0]);
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {};
  },
  methods: {
    onTab(item) {
      this.$emit("update:selectTab", item);
      console.log("itemitemitemitem", item);
      this.$emit("tabFn", item);
    }
  }
};